import { render, staticRenderFns } from "./CustomsCodeFetchList.vue?vue&type=template&id=26283699&scoped=true"
import script from "./CustomsCodeFetchList.vue?vue&type=script&lang=js"
export * from "./CustomsCodeFetchList.vue?vue&type=script&lang=js"
import style0 from "./CustomsCodeFetchList.vue?vue&type=style&index=0&id=26283699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26283699",
  null
  
)

export default component.exports